module.exports = __webpack_public_path__ + "img/drug-27.b4e4e232.png";